"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This symbol identifies an action for processing in the
 * secondary API auth middleware.
 */
exports.PROTECTED = Symbol("PROTECTED");
